module.exports = __webpack_public_path__ + "assets/images/Caixa-mercia_7d2b72add379c4378bd1b5767f16814f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-two/Caixa-mercia.png
// module id = 203
// module chunks = 0